import {makeGet} from '@logistics-frontend/utils'

import {DestinationPointDeliveryMethod, Order as FormValues} from '../../../types'
import {toDestinationPoints} from '../../../utils/to-destination-point'

export function withEmptyDestinationPoint() {
  const sddClaimInfo = undefined
  const isCard = true

  return function _withEmptyDestinationPoint(formValues: FormValues) {
    const sourceCity = getSourceCity(formValues)
    const destinationCity = getDestinationCity(formValues)
    if (sourceCity !== destinationCity || destinationCity === '') {
      formValues.destinationPoints = toDestinationPoints(
        sddClaimInfo,
        isCard,
        DestinationPointDeliveryMethod.PickUpPoint,
      )
    }

    return formValues
  }
}

const valuesGet = makeGet<FormValues>()
export const getSourceCity = valuesGet('sourcePoint.address.city')
export const getDestinationCity = valuesGet('destinationPoints[0].address.city')
